module.exports = __webpack_public_path__ + "img/KD75X80K.950c0102.jpg";